export default "__VITE_ASSET__BWSfKZNk__"